
import Gumshoe from 'gumshoejs'

export const aboutMenuInit = () => {
  new Gumshoe('.pageAsideMenu a', {
    reflow: true,
    offset: 70
  })
}
